/**
 * Fixture sets available to demo generation. Each value must match a directory
 * under `backend/src/modules/demoAccount/fixtures/`.
 */
export const DEMO_FIXTURE_ENVIRONMENTS = ["default", "dev", "sales"] as const;

export type DemoFixtureEnvironment = (typeof DEMO_FIXTURE_ENVIRONMENTS)[number];

export const DEFAULT_DEMO_FIXTURE_ENVIRONMENT: DemoFixtureEnvironment =
    "default";

export const DEFAULT_DEMO_CLIENT_NAME = "Demo client";
